// $( document ).ready(function() {
//     $(document).on("click", ".shoppable-image__hotspot", function() {
//         location.href = $(this).attr("data-href");
//     })
// });

// SH Update - Removing JQuery
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".shoppable-image__hotspot").forEach(function(hotspot) {
        hotspot.addEventListener("click", function() {
            const url = this.getAttribute("data-href");
            if (url) {
                window.location.href = url;
            } else {
                console.error("Hotspot URL is missing!");
            }
        });
    });
});